import React, {useCallback, useEffect, useMemo, useState} from "react";
/*import {Column, Pie, PieConfig} from "@ant-design/charts";*/
import {useTranslation} from "react-i18next";
import {Col, Row, Select, Tabs, Tag, Table} from "antd";
import {ColumnsType,} from "antd/lib/table";
import {Link} from "react-router-dom";
import moment from "moment";/*
import {RangePickerProps} from "antd/lib/date-picker";
import {parseISO} from "date-fns";*/
import {Card, Label} from "../../../components/ui";
import api from "../../../services/api";
import {useToast} from "../../../hooks/toast";

import "./styles.less";
import {IProjectType} from "../../Projects";
import {Filters, FiltersCard} from "../../../components/Filters";
import filterOptions from "../../../utils/filterOptions";
import FormItem from "../../../components/FormItem";
import {removeEmptyKeys} from "../../../utils/formatters";
import "./styled.css";
import ProjectTypes from "../../../enums/ProjectTypes";

interface IProject {
  id: string;
  short_description: string;
  identifier: string;
  contractor_name: string;
  estimated: number;
  wasted: number;
  completion_date: string;
  expected_end: string;
  project_type?: ProjectTypes;
}

interface IInTimeOutdatedProjectsStats {
  stats: {
    ongoingOutdated: number;
    concludedOutdated: number;
    noExpectedEndDate: number;
    inTime?: number;
  };
  ongoingOutdated: IProject[];
  concludedOutdated: IProject[];
  noExpectedEndDate: IProject[];
}

const InTimeOutdatedProjectsStats: React.FC = () => {
  const {t} = useTranslation(["projects", "dashboards", "users"]);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IInTimeOutdatedProjectsStats>();
  const [projectsTypes, setProjectsTypes] = useState<IProjectType[]>([]);
  const [showFilters, setShowFilters] = useState(false);
  const [filterTypeProjects, setFilterTypeProjects] = useState<
    string | undefined
  >(undefined);

  const {addToast} = useToast();

  const Params = useMemo(() => {
    return {
      project_type_id: filterTypeProjects,
    };
  }, [filterTypeProjects]);

  useEffect(() => {
    setLoading(true);
    api
      .get<IInTimeOutdatedProjectsStats>("/dashboards/outdated-projects", {
        params: removeEmptyKeys(Params),
      })
      .then(response => setData(response.data))
      .catch(() => {
        addToast({
          type: "error",
          title: "Erro na busca",
          description:
            "Occoreu um erro ao buscar os projetos, tente novamente.",
        });
      })
      .finally(() => setLoading(false));
  }, [addToast, Params]);

  useEffect(() => {
    api
      .get<IProjectType[]>("/project-types")
      .then(response => setProjectsTypes(response.data))
      .catch(() => {
        addToast({
          type: "error",
          title: "Erro ao buscar tipos de projetos",
          description: "Ocorreu um erro ao buscar os tipos de projetos",
        });
      });
  }, [addToast]);

  const projectOption = useMemo(() => {
    return projectsTypes.map(projectType => ({
      value: projectType.id,
      label: t(`project-types.options.${projectType.acronym}.label`),
    }));
  }, [t, projectsTypes]);

  /*  const config: PieConfig = useMemo(
      () => ({
        data: [
          {
            category: t("ongoing-outdated", { ns: "dashboards" }),
            count: data?.stats.ongoingOutdated,
          },
          {
            category: t("concluded-outdated", { ns: "dashboards" }),
            count: data?.stats.concludedOutdated,
          },
          {
            category: t("no-expected-end-date", { ns: "dashboards" }),
            count: data?.stats.noExpectedEndDate,
          },
          {
            category: t("in-time", { ns: "dashboards" }),
            count: data?.stats.inTime,
          },
        ],
        angleField: "count",
        colorField: "category",
        innerRadius: 0.6,
        // label: {
        //   type: "spider",
        //   labelHeight: 28,
        //   content: "{name}\n{percentage}",
        // },
        legend: false,
        label: undefined,
        // autoFit: true,
        height: 250,
        width: 250,
        interactions: [{ type: "element-selected" }, { type: "element-active" }],
      }),
      [
        data?.stats.concludedOutdated,
        data?.stats.inTime,
        data?.stats.noExpectedEndDate,
        data?.stats.ongoingOutdated,
        t,
      ],
    );*/

  const ongoingOutdatedProjectColumns: ColumnsType<IProject> = useMemo(
    () => [
      {
        title: t("identifier"),
        dataIndex: "identifier",
      },
      {
        title: t("short_description"),
        dataIndex: "short_description",
        render: (description, project: IProject) => {
          return (
            <>
              <Link to={`/app/projects/${project.id}`}>{description}</Link>
            </>
          );
        },
      },
      {
        title: t("status.label"),
        dataIndex: "status",
        render: (status: string) => {
          return (
            <Tag color={t(`status.options.${status}.color`)} key={status}>
              {t(`status.options.${status}.label`)}
            </Tag>
          );
        },
      },
      {
        title: t("type"),
        dataIndex: "project_type",
        render: (project_type: string) => {
          return (<Tag
            color={t(`project-types.options.${project_type}.color`)}
            key={project_type}
          >
            {t(`project-types.options.${project_type}.label`)}
          </Tag>)
        }
      },
      {
        title: t("contractor_name"),
        dataIndex: "contractor_name",
      },
      {
        title: t("estimated"),
        dataIndex: "estimated",
      },
      {
        title: t("wasted"),
        dataIndex: "wasted",
      },
      {
        title: t("expected_end"),
        dataIndex: "expected_end",
        render: (date: string) =>
          date && moment(date, "DD-MM-YYYY").format("DD/MM/YYYY"),
      },
    ],
    [t],
  );

  const concludedOutdatedProjectColumns: ColumnsType<IProject> = useMemo(
    () => [
      {
        title: t("identifier"),
        dataIndex: "identifier",
      },
      {
        title: t("short_description"),
        dataIndex: "short_description",
        render: (description, project: IProject) => {
          return (
            <>
              <Link to={`/app/projects/${project.id}`}>{description}</Link>
            </>
          );
        },
      },
      {
        title: t("type"),
        dataIndex: "project_type",
        render: (project_type: string) => {
          return (<Tag
            color={t(`project-types.options.${project_type}.color`)}
            key={project_type}
          >
            {t(`project-types.options.${project_type}.label`)}
          </Tag>)
        }
      },
      {
        title: t("contractor_name"),
        dataIndex: "contractor_name",
      },
      {
        title: t("estimated"),
        dataIndex: "estimated",
      },
      {
        title: t("wasted"),
        dataIndex: "wasted",
      },
      {
        title: t("completion_date"),
        dataIndex: "completion_date",
        render: date => date && moment(date, "DD-MM-YYYY").format("DD/MM/YYYY"),
      },
      {
        title: t("expected_end"),
        dataIndex: "expected_end",
        render: date => date && moment(date, "DD-MM-YYYY").format("DD/MM/YYYY"),
      },
    ],
    [t],
  );

  const noExpectedEndDateProjectColumns: ColumnsType<IProject> = useMemo(
    () => [
      {
        title: t("identifier"),
        dataIndex: "identifier",
      },
      {
        title: t("short_description"),
        dataIndex: "short_description",
        render: (description, project: IProject) => {
          return (
            <>
              <Link to={`/app/projects/${project.id}`}>{description}</Link>
            </>
          );
        },
      },
      {
        title: t("contractor_name"),
        dataIndex: "contractor_name",
      },
      {
        title: t("status.label"),
        dataIndex: "status",
        render: (status: string) => {
          return (
            <Tag color={t(`status.options.${status}.color`)} key={status}>
              {t(`status.options.${status}.label`)}
            </Tag>
          );
        },
      },
      {
        title: t("estimated"),
        dataIndex: "estimated",
      },
      {
        title: t("wasted"),
        dataIndex: "wasted",
      },
      {
        title: t("completion_date"),
        dataIndex: "completion_date",
        render: date => date && moment(date, "DD-MM-YYYY").format("DD/MM/YYYY"),
      },
    ],
    [t],
  );

  const pagination =  true as any;

  const handleFilters = useCallback(() => {
    if (showFilters) {
      setFilterTypeProjects(undefined);
    }
    setShowFilters(old => !old);
  }, [showFilters]);

  return (
    <Card
      loading={loading}
      title={
        <>
          <div>
            {t("outdate-in-time-projects", {ns: "dashboards"})}
            <Filters showFilters={showFilters} setShowFilters={handleFilters}/>
          </div>
          <div>
            {showFilters ? (
              <FiltersCard>
                <Col lg={12} md={12} sm={24} xl={9} xs={24}>
                  <div>
                    <Label color="#575962">{t("project-types.label")}</Label>
                  </div>
                  <FormItem>
                    <Select
                      showSearch
                      allowClear
                      disabled={loading}
                      placeholder={t("project-types.placeholder")}
                      onChange={
                        projectType => setFilterTypeProjects(projectType)
                        // ts-ignore
                      }
                      options={projectOption}
                      filterOption={filterOptions}
                    />
                  </FormItem>
                </Col>
              </FiltersCard>
            ) : (
              <></>
            )}
          </div>
        </>
      }
    >
      {/*<Row gutter={[20, 20]} align="middle">*/}
      {/*<Col lg={18} md={24} xl={18}>*/}
      <Tabs defaultActiveKey="1">
        <Tabs.TabPane
          tab={t("ongoing-outdated", {ns: "dashboards"})}
          key="1"
          style={{minHeight: 300}}
        >
          <Table
            className="table-striped"
            style={{marginTop: 20}}
            scroll={{
              x: "max-content",
              // y: maxHeight,
            }}
            dataSource={data?.ongoingOutdated || []}
            columns={ongoingOutdatedProjectColumns}
            pagination={undefined}
            rowKey={record => record.id}
            size="small"
          />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={t("concluded-outdated", {ns: "dashboards"})}
          key="2"
          style={{minHeight: 300,}}
        >
          <Table
            className="table-striped"
            style={{marginTop: 20}}
            scroll={{
              x: "max-content",
              // y: maxHeight,
            }}
            rowKey={record => record.id}
            dataSource={data?.concludedOutdated || []}
            columns={concludedOutdatedProjectColumns}
            size="small"
          />
        </Tabs.TabPane>
        {/*<Tabs.TabPane
              tab={t("no-expected-end-date", {ns: "dashboards"})}
              key="3"
              style={{minHeight: 300}}
            >
              <Table
                className="table-striped"
                style={{marginTop: 20}}
                scroll={{
                  x: "max-content",
                  // y: maxHeight,
                }}
                dataSource={data?.noExpectedEndDate || []}
                rowKey={record => record.id}
                columns={noExpectedEndDateProjectColumns}
                pagination={{
                  defaultCurrent: 1,
                  total: data?.noExpectedEndDate.length,
                  defaultPageSize: 10,
                }}
                size="small"
              />
            </Tabs.TabPane>*/}
      </Tabs>
      {/*</Col>*/}
      {/* <Col lg={6} md={24} xl={6}>
          <Pie {...config} />
        </Col>*/}
      {/*   </Row>*/}
    </Card>
  );
};

export default InTimeOutdatedProjectsStats;
